
import pako from 'pako';

export class GZIPService {

    static decode(base64Str) {
        try {
            if (!base64Str) { return null;}
            const compressed = this.base64ToUint8Array(base64Str);
            const decompressed = pako.ungzip(compressed, { to: 'string' });
            return JSON.parse(decompressed);
        } catch (e) {
            return null;
        }
    }

    static base64ToUint8Array(base64) {
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }
}